import type { SimState, Vehicle } from './model';
import type { PublishedVehicle } from './catalogEvidence';

const localTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Berlin',
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});
export function onDuty(evidence: PublishedVehicle | undefined, now: number) {
  if (!evidence?.dutyWindows) return true; // No published hours: simulated availability.
  const parts = Object.fromEntries(localTime.formatToParts(now).map((p) => [p.type, p.value]));
  const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(parts.weekday) + 1;
  const minute = Number(parts.hour) * 60 + Number(parts.minute);
  return evidence.dutyWindows.some(
    (w) => w.days.includes(day) && minute >= w.startMinute && minute < w.endMinute,
  );
}
export function available(v: Vehicle, now: number) {
  return (
    [1, 2].includes(v.status) &&
    !v.incidentId &&
    !v.catalogRetire &&
    !(v.mutualAid && v.journey?.returning) &&
    onDuty(v.evidence, now)
  );
}
export function reconcileAvailability(s: SimState) {
  s.vehicles = s.vehicles.filter(
    (v) => !(v.mutualAid && v.status === 2 && !v.incidentId && !v.journey),
  );
  s.stations = s.stations.filter(
    (w) => !w.temporaryAid || s.vehicles.some((v) => v.stationId === w.id),
  );
  for (const v of s.vehicles) {
    if (v.incidentId || v.journey) continue;
    if (!onDuty(v.evidence, s.now) && (v.status === 2 || v.status === 1)) {
      v.status = 6;
      v.scheduleOffDuty = true;
    } else if (onDuty(v.evidence, s.now) && v.scheduleOffDuty) {
      v.status = 2;
      v.scheduleOffDuty = false;
    }
  }
}
